import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateReviewAccountBody, UpdateReviewAccountBody } from '@sparkapp/shared-types';
import { reviewAccountsApi } from '../services/reviewAccountsApi';
import { queryKeys } from '../utils/queryKeys';

function useInvalidateReviewAccounts() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: queryKeys.reviewAccounts.all });
}

export function useReviewAccounts() {
  return useQuery({ queryKey: queryKeys.reviewAccounts.list(), queryFn: reviewAccountsApi.list });
}

export function useCreateReviewAccount() {
  const onSuccess = useInvalidateReviewAccounts();
  return useMutation({ mutationFn: (body: CreateReviewAccountBody) => reviewAccountsApi.create(body), onSuccess });
}

export function useUpdateReviewAccount() {
  const onSuccess = useInvalidateReviewAccounts();
  return useMutation({
    mutationFn: ({ userId, body }: { userId: number; body: UpdateReviewAccountBody }) =>
      reviewAccountsApi.update(userId, body),
    onSuccess,
  });
}

export function useRemoveReviewAccount() {
  const onSuccess = useInvalidateReviewAccounts();
  return useMutation({ mutationFn: (userId: number) => reviewAccountsApi.remove(userId), onSuccess });
}
